<template>
  <div class="container-fluid">
    <div class="login">
      <div class="card p-sm-5 p-3" style="width: 40rem;">
        <div class="card-body">
          <h5 class="card-title text-center">
            <img width="60%" src="/assets/logo/logo_white.svg" />
          </h5>

          <form action="#" class="mt-5">
            <div class="text-white text-center">
              <h6 class="text-uppercase" v-html="successMessage"></h6>
            </div>

            <div class="text-center ">
              <a
                href="/login"
                type="submit"
                class="btn btn-dark mt-4  ml-md-3 ml-0"
              >
                Inloggen
              </a>
            </div>
          </form>
        </div>
      </div>
      <bottomDots v-bind:step="step"></bottomDots>
    </div>
  </div>
</template>

<script>
import bottomDots from "./bottomDots";

export default {
  components: { bottomDots },
  computed: {
    successMessage: () => process.env.VUE_APP_REGISTER_MESSAGE,
  },
  data() {
    return {
      step: "step3",
    };
  },
};
</script>

<style scoped>
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.login {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 18px !important;
}
</style>
